var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGpsPosition = function SvgGpsPosition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 41,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 83,
    viewBox: "0 0 82 83"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 42,
    r: 41,
    fill: "#061AB1",
    opacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 8.5,
    fill: "#061AB1",
    stroke: "#fff",
    transform: "matrix(-1 0 0 1 48 35)"
  }))));
};
export default SvgGpsPosition;